import config from '@/config'

export default {
	id: 'SIMPLE_PAYWALL_12W_59_99_12W_59_99',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_v2_12w_59_99_12w_59_99_usd',
			ARS: 'simple_premium_12w_79990_12w_79990_ars',
			COP: 'simple_premium_12w_239990_12w_239990_cop',
			CLP: 'simple_premium_12w_57990_12w_57990_clp',
		},
		primer: 'prd_2mwQhN5AiSNE',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 12,
		intro_period_type: 'week',
		next_period_value: 12,
		next_period_type: 'week',
	},
	trial: {
		days: 84,
		priceMap: {
			USD: 59.99,
			EUR: 59.99,
			GBP: 59.99,
			AUD: 99.99,
			CAD: 99.99,
			DKK: 459,
			SEK: 699,
			NOK: 699,
			BRL: 299.99,
			MXN: 999,
			TRY: 1999,
			ARS: 79990,
			COP: 239990,
			CLP: 57990,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 59.99,
			EUR: 59.99,
			GBP: 59.99,
			AUD: 99.99,
			CAD: 99.99,
			DKK: 459,
			SEK: 699,
			NOK: 699,
			BRL: 299.99,
			MXN: 999,
			TRY: 1999,
			ARS: 79990,
			COP: 239990,
			CLP: 57990,
		},
	},
}
